import React from "react";
import ModalFormDestino from "./ModalFormDestino";

const ModalDestino = ({ show, handleClose, destino }) => {
  return (
    <ModalFormDestino show={show} handleClose={handleClose} destino={destino} />
  );
};

export default ModalDestino;
